import { tv } from 'tailwind-variants';

export const buttonVariants = tv({
  base: 'inline-flex items-center min-w-[117px] text-black justify-center px-5 py-3.5 whitespace-nowrap rounded-full gap-2 font-semibold disabled:pointer-events-none disabled:opacity-[0.20]',
  variants: {
    variant: {
      primary: 'bg-yellow hover:bg-yellow-accent',
      secondary:
        'bg-black text-white hover:bg-white hover:border-2 hover:border-solid hover:border-black hover:text-black',
      tertiary:
        'bg-white border-2 border-solid border-black hover:text-white hover:bg-black',
    },
    size: {
      xsmall: 'h-8 text-xs',
      small: 'h-10 text-sm',
      large: 'h-12 text-base',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'large',
  },
});
